import {
	PreworkReviewAction,
	PreworkCompletionStatus as PreWorkStatus,
} from './PreWorkServiceTypes';

export const FIREBASE_ID_TOKEN = 'FIREBASE_ID_TOKEN';
export const FIREBASE_ID = 'FIREBASE_ID';

export const KEYCLOAK_ID_TOKEN = 'KEYCLOAK_ID_TOKEN';
export const CURRENT_ACTIVE_BATCH = 'CURRENT_ACTIVE_BATCH';
export const ME_PROFILE = 'ME_PROFILE';
export const LOGGED_IN_USER_ROLES = 'LOGGED_IN_USER_ROLES';
export const LOGGED_IN_USER_PRIVILEGES = 'LOGGED_IN_USER_PRIVILEGES';
export const SELECTED_ROLE = 'SELECTED_ROLE';
export const ROLES_WITH_MODULES = 'ROLES_WITH_MODULES';
export const APP_INITIATED = 'APP_INITIATED';

export const DisplayRole = {
	SNP_ADMIN: 'SNP Admin',
	PREWORK_ADMIN: 'Pre-work Admin',
	PREWORK_MENTOR: 'Pre-work Mentor',
	SCREENING_ADMIN: 'Screening Admin',
	APPROVER: 'Approver',
	PROPOSER: 'Proposer',
	CARE_TEAM: 'Care Team',
	ZC: 'ZC',
	EXAM_ADMIN: 'Exam Admin',
	NPS_ADMIN: 'NPS Admin',
	NPS_MENTOR: 'NPS Mentor',
	PRECEPTOR: 'Preceptor',
	APPLICANT: 'Applicant',
};

export const DEFAULT_PAGE_INDEX = 0;
export const DEFAULT_PAGE_SIZE = 20;
export const OTP_REGENERATION_INTERVAL_IN_SECONDS = 59;
export const OTP_EXPIRATION_INTERVAL_IN_SECONDS = 599;
export const PAGE_SIZE = 200;

export const VALID_ABHYASI_ID_REGEX =
	/^([a-zA-Z]{6}[0-9]{3}|[HABhab]{1}[0-9]{8})$/;
export const VALID_TEMP_ABHYASI_ID_REGEX = /^([HABhab]{1}[0-9]{8})$/;
export const VALID_STRING_INPUT_REGEX =
	/^(?! )[^\s](?!.* {2})[\p{Script=Devanagari}\p{Script=Bengali}\p{Script=Gurmukhi}\p{Script=Gujarati}\p{Script=Oriya}\p{Script=Tamil}\p{Script=Telugu}\p{Script=Kannada}\p{Script=Malayalam}\p{Script=Sinhala}\p{Script=Thai}\p{Script=Lao}\p{Script=Tibetan}\p{Script=Latin}\d,."?'\n\- ]*$/u;
export const VALID_ADDRESS_REGEX =
	/^[\p{Script=Devanagari}\p{Script=Bengali}\p{Script=Gurmukhi}\p{Script=Gujarati}\p{Script=Oriya}\p{Script=Tamil}\p{Script=Telugu}\p{Script=Kannada}\p{Script=Malayalam}\p{Script=Sinhala}\p{Script=Thai}\p{Script=Lao}\p{Script=Tibetan}\p{Script=Latin} \d,.:"?'\n\- ]+$/u;
export const VALID_CITY_REGEX =
	/^([a-zA-Z\u0080-\u024F]+(?:. |-| |'))*[a-zA-Z\u0080-\u024F]*$/;
export const VALID_PINCODE_REGEX = /^[1-9]{1}[0-9]{2}\s?[0-9]{3}$/;
export const VALID_BATCH_REGEX = /^[0-9]{4}-[0-9]{2}$/;
export const VALID_NAME_REGEX = /^(?!\s*$)[a-zA-Z.]+(?: [a-zA-Z.]+)*$/;
export const VALID_EMAIL_REGEX = /^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
export const VALID_BATCH_NAME_REGEX = /^(?!\s*$).+/;
export const VALID_PHONE_REGEX = /^([+]\d{2})?\d{10}$/;
export const NO_WHITESPACE_REGEX = /^(?!\s*$).+/;
export const MAX_PRECEPTORS_FOR_GROUP = 5;
export const MAX_CANDIDATES_FOR_GROUP = 5;

export const ApplicationStatus = {
	NOT_YET_APPLIED: 'NOT_YET_APPLIED',
	USER_SUBMITTED_APPLICATION: 'USER_SUBMITTED_APPLICATION',
	FUNCTIONARY_ASSIGNED: 'FUNCTIONARY_ASSIGNED',
	FUNCTIONARY_SUBMITTED: 'FUNCTIONARY_SUBMITTED',
	WAITING_FOR_CARE_TEAM: 'WAITING_FOR_CARE_TEAM',
	APPROVED: 'APPROVED',
	REJECTED: 'REJECTED',
	SYS_ANOTHER_FUNCTIONARY_ASSIGNED: 'SYS_ANOTHER_FUNCTIONARY_ASSIGNED',
	DRAFT: 'DRAFT',
};

export const Gender = {
	NOT_PROVIDED: 'NOT_PROVIDED',
	MALE: 'MALE',
	FEMALE: 'FEMALE',
};

export const ReferenceCategory = {
	PRECEPTOR: 'PRECEPTOR',
	FAMILY_MEMBER: 'FAMILY_MEMBER',
	OTHER_REFERENCE: 'OTHER_REFERENCE',
};

export const NewApplicationNotAllowedReason = {
	SUBMITTED_APPLICATION_IN_THE_PAST: 'SUBMITTED_APPLICATION_IN_THE_PAST',
	BLACKLISTED: 'BLACKLISTED',
	UNDER_REVIEW: 'UNDER_REVIEW',
	BATCH_CLOSED: 'BATCH_CLOSED',
};

export const EvaluationCategoryID = {
	INSPIRATION_AND_WILLINGNESS: 1,
	PRACTICE: 2,
	CHARACTER_AND_HABITS: 3,
	AVAILABILITY_AFTER_PROGRAM: 4,
	SUPPORT: 5,
	UNDERSTANDING_OF_HEARTFULNESS: 6,
	BASIC_ELIGIBILITY: 7,
	DIETARY_HABITS_AND_HEALTH: 8,
	PRE_WORK: 9,
};

export const CardIndex = {
	HEARTFULNESS_PROFILE: 0,
	ADDITIONAL_DETAILS: 1,
	TRAINING_COURSE_DETAILS: 2,
	PRECEPTOR_CONTACT_DETAILS: 3,
	FAMILY_MEMBER_DETAILS: 4,
	OTHER_REFERENCE_DETAILS: 5,
	WELCOME_AND_SELF_CONSCIOUSNESS: 6,
	BASIC_ELIGIBILITY: 7,
	INSPIRATION_AND_WILLINGNESS: 8,
	PRACTICE: 9,
	CHARACTER_AND_HABITS: 10,
	AVAILABILITY_AFTER_PROGRAM: 11,
	SUPPORT: 12,
	UNDERSTANDING_OF_HEARTFULNESS: 13,
	DIETARY_HABITS_AND_HEALTH: 14,
	TERMS_AND_CONDITIONS: 15,
};

export const EssentailCardIndex = {
	BASIC_ELIGIBILITY: 0,
	INSPIRATION_AND_WILLINGNESS: 1,
	PRACTICE: 2,
	CHARACTER_AND_HABITS: 3,
	AVAILABILITY_AFTER_PROGRAM: 4,
	SUPPORT: 5,
	UNDERSTANDING_OF_HEARTFULNESS: 6,
	DIETARY_HABITS_AND_HEALTH: 7,
	TERMS_AND_CONDITIONS: 8,
};

export const ReviewAction = {
	APPROVE: 'APPROVE',
	APPROVE_IDK_CANDIDATE: 'APPROVE_IDK_CANDIDATE',
	NOT_GOING_FORWARD: 'NOT_GOING_FORWARD',
	REJECT: 'REJECT',
	ON_HOLD: 'ON_HOLD',
	NOT_APPLICABLE: 'NOT_APPLICABLE_REVIEW',
	PENDING: 'PENDING',
};

export const ReapplyCondition = {
	NOT_APPLICABLE_CONDITION: 'NOT_APPLICABLE_CONDITION',
	BLACK_LISTED: 'BLACK_LISTED',
	AVAILABLE_FROM_TOMORROW: 'AVAILABLE_FROM_TOMORROW',
	AFTER_3_MONTHS: 'AFTER_3_MONTHS',
	AFTER_6_MONTHS: 'AFTER_6_MONTHS',
	AFTER_12_MONTHS: 'AFTER_12_MONTHS',
};

export const PersonRole = {
	AN_ABHYASI: 'AN_ABHYASI',
	A_PRECEPTOR: 'A_PRECEPTOR',
	NOT_YET_AN_ABHYASI: 'NOT_YET_AN_ABHYASI',
};

export const Relationship = {
	SPOUSE: 'Spouse',
	PARENT: 'Parent',
	OTHER: 'Other',
};

export const PredefinedReasonCategory = {
	SKIP: 'SKIP',
	REJECT: 'REJECT',
	PROPOSER_REJECT: 'PROPOSER_REJECT',
	PRECEPTOR_REJECT: 'PRECEPTOR_REJECT',
	APPROVER_REJECT: 'APPROVER_REJECT',
	ZC_REJECT: 'ZC_REJECT',
	CARE_TEAM_REJECT: 'CARE_TEAM_REJECT',
};

export const MedicationQuestionId = {
	NEW_APPLICATION_ONE: 42,
	NEW_APPLICATION_TWO: 43,
	NEW_APPLICATION_THREE: 44,
	APPLICANT_INTERVIEW: 100,
	PRECEPTOR_INTERVIEW: 101,
	FAMILY_MEMBER_INTERVIEW: 102,
	BASIC_ELIGIBILITY_APPLICANT_INTERVIEW: 103,
};

export const AnswerOptionsField = {
	RADIO: 'RADIO',
	SELECT: 'SELECT',
	BUTTONS: 'BUTTONS',
};

export const FunctionaryType = {
	PROPOSER: 'PROPOSER',
	APPROVER: 'APPROVER',
	ZC: 'ZC',
	CARE_TEAM: 'CARE_TEAM',
	PREWORK_ADMIN: 'PREWORK_ADMIN',
	NPS_ADMIN: 'NPS_ADMIN',
	SCREENING_ADMIN: 'SCREENING_ADMIN',
	NPS_MENTOR: 'NPS_MENTOR',
	PREWORK_MENTOR: 'PREWORK_MENTOR',
	SNP_ADMIN: 'SNP_ADMIN',
	EXAM_ADMIN: 'EXAM_ADMIN',
};

export const PreWorkQuestionId = {
	HEARTFUL_COMMUNICATION: 600,
	SYSTEM_GENERATED: 601,
	CANDIDATE_VIEW_ON_COMPLETION: 603,
	MENTOR_CONCERNS_QUESTION: 650,
	MENTOR_SYSTEM_GENERATED: 651,
};

export const PreworkCompletionStatus = {
	NOT_STARTED: 'NOT_STARTED',
	INCOMPLETE: 'INCOMPLETE',
	PARTIALLY_COMPLETED: 'PARTIALLY_COMPLETED',
	COMPLETED: 'COMPLETED',
};

export const allPreworkRecommendationStatuses = [
	PreworkReviewAction.PREWORK_APPROVE,
	PreworkReviewAction.PREWORK_REJECT,
	PreworkReviewAction.EXTEND_TO_PREWORK_MENTOR,
	PreworkReviewAction.PENDING,
];

export const allPreworkStatuses = [
	PreWorkStatus.COMPLETED,
	PreWorkStatus.INCOMPLETE,
	PreWorkStatus.PARTIALLY_COMPLETED,
	PreWorkStatus.NOT_STARTED,
];

export const GroupTabs = {
	CREATE_GROUP: '1',
	GROUPS_LIST_VIEW: '2',
	VIEW_ALL_NEW_PRECEPTORS: '3',
	GRAPHICAL_VIEW: '4',
	BATCHES: '5',
};

export const PreworkGroupTabs = {
	CREATE_GROUP: '1',
	GROUPS_LIST_VIEW: '2',
	VIEW_ALL_NEW_CANDIDATES: '3',
	GRAPHICAL_VIEW: '4',
	BATCHES: '5',
};

export const TOTAL_NO_OF_NPS_CARDS = 5;
export const COUNTRY_CODE_INDIA = 358;
export const COUNTRY_CODE_INDIA_FOR_REGIONS = 49;

export const EXAM_LANGUAGES = [
	'Hindi',
	'Telugu',
	'Bengali',
	'English',
	'Malayalam',
	'Tamil',
	'Marathi',
	'Gujarati',
	'Kannada',
];

export const MARK_RANGES = [
	'0-5',
	'0-10',
	'0-15',
	'0-20',
	'0-25',
	'0-30',
	'0-35',
	'0-40',
	'0-45',
	'0-50',
	'0-55',
	'0-60',
	'0-65',
	'0-70',
	'0-75',
	'0-80',
	'0-85',
	'0-90',
	'0-95',
	'0-100',
];

export const DATE_DD_MMM_YYYY = 'DD MMM YYYY';
export const DATE_DO_MMM_YYYY = 'Do MMM, YYYY';
export const DATE_DO_MMMM_YYYY = 'Do MMMM YYYY';
export const TIME_H_MM_A = 'h:mm A';
export const DATE_DD_MM_YYYY = 'DD.MM.YYYY';

export const GraphTabs = {
	REGISTRATION_GRAPH: '1',
	RESULTS_GRAPH: '2',
};
export const PROJECT_CODE_FOR_MAINTENANCE = 'snp';
export const TABLE_VIEW_LABEL = 'Table View';
export const GRAPH_VIEW_LABEL = 'Graph View';
export const TABLE_VIEW_VALUE = 'TABLE_VIEW';
export const GRAPH_VIEW_VALUE = 'GRAPH_VIEW';
export const RESULTS_VIEW_OPTIONS = [
	{ label: TABLE_VIEW_LABEL, value: TABLE_VIEW_VALUE },
	{ label: GRAPH_VIEW_LABEL, value: GRAPH_VIEW_VALUE },
];
export const SNP_MODULE = {
	nps: 'NPS',
	Prework: 'Prework',
};

export const NPS_PATH = '/nps';
export const PREWORK_PATH = '/prework';
export const NGF = 'Not Going Forward';

export const ME_PROFILE_FIELDS = [
	'id',
	'name',
	'first_name',
	'middle_name',
	'last_name',
	'ref',
	'email',
	'srcm_group',
	'age',
	'gender',
	'first_sitting_by',
	'resp_prefect',
	'is_prefect',
	'date_of_birth',
	'date_of_joining',
	'photo_url',
	'street',
	'street2',
	'street3',
	'street4',
	'postal_code',
	'city',
	'city_id',
	'state',
	'country',
	'mobile',
	'mobile2',
	'phone',
	'phone2',
	'skills',
	'profession',
	'prefect_status',
	'user_firebase_uid',
	'languages',
];

export const POSITION_ASSIGNMENTS_FIELDS = [
	'position_type_code',
	'gender',
	'ref',
	'srcm_group',
	'partner',
];
export const CTDCategories = {
	ALL_APPROVED: 'allApprovedCount',
	ZC_REJECTED_PROPOSER_AND_RC_APPROVED:
		'zcRejectedButProposerAndRCApprovedCount',
	RC_AND_ZC_REJECTED_PROPOSER_APPROVED:
		'rcAndZCRejectedButProposerApprovedCount',
	PROPOSER_AND_ZC_APPROVED_RC_REJECTED:
		'proposerAndZCApprovedButRCRejectedCount',
	PROPOSER_REJECTED_ZC_and_RC_APPROVED:
		'proposerRejectedButZCAndRCApprovedCount',
	PROPOSER_AND_RC_REJECTED_ZC_APPROVED:
		'proposerAndRCRejectedButZCApprovedCount',
	PROPOSER_AND_ZC_REJECTED_RC_APPROVED:
		'proposerAndZCRejectedButRCApprovedCount',
	PROPOSER_APPROVED_AND_RC_REJECTED_BUT_ZC_NOT_PROVIDED_RECOMMENDATION_COUNT:
		'proposerApprovedAndRCRejectedButZCNotProvidedRecommendationCount',
	PROPOSER_REJECTED_AND_RC_APPROVED_BUT_ZC_NOT_PROVIDED_RECOMMENDATION_COUNT:
		'proposerRejectedAndRCApprovedButZCNotProvidedRecommendationCount',
	PROPOSER_AND_RC_APPROVED_BUT_ZC_NOT_PROVIDED_RECOMMENDATION_COUNT:
		'proposerAndRCApprovedButZCNotProvidedRecommendationCount',
	PROPOSER_AND_RC_REJECTED_BUT_ZC_NOT_PROVIDED_RECOMMENDATION_COUNT:
		'proposerAndRCRejectedButZCNotProvidedRecommendationCount',
	ALL_REJECTED: 'allRejectedCount',
};

export const FROM_CTD = 'FROM_CTD';
export const FROM_SCREENING_DASHBOARD = 'FROM_SCREENING_DASHBOARD';
export const STEPS_STATUS = {
	FINISH: 'finish',
	PROCESS: 'process',
	WAIT: 'wait',
} as const;
export const DEFAULT_DATE = '1970-01-01T00:00:00Z';

export const GENDER_MAP: Record<string, string> = {
	M: Gender.MALE,
	F: Gender.FEMALE,
};

export const DATE_FORMAT_DD_MM_YYYY = 'DD/MM/YYYY';
export const API_DATE_FORMAT = 'YYYY-MM-DD';
// constants/formConstants.ts

export const REQUIRED_FIELDS = ['name', 'gender', 'email', 'mobile'];

export const FIELD_LABEL_KEYS: Record<string, string> = {
	name: 'name',
	gender: 'gender',
	email: 'email',
	mobile: 'mobile',
};

interface AddFunctionaryUiConfig {
	hideHomeMappings: boolean;
}

export const ADD_FUNCTIONARY_UI_CONFIG: AddFunctionaryUiConfig = {
	hideHomeMappings: true,
};

export const FUNCTIONARY_TYPE_LABELS: Record<string, string> = {
	SNP_ADMIN: 'SNP Admin',
	NPS_ADMIN: 'NPS Admin',
};
